/* eslint-disable react/forbid-prop-types */
import React from "react"
import propTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"
import ReactPlayer from "react-player"
import SEO from "../components/Seo"
import InstagramFeed from "../components/InstagramFeed"

const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    background: #cccaca;
  }
`

const IndexPage = ({ data }) => {
  return (
    <>
      <PlayerWrapper>
        <SEO title="Home" />
        <ReactPlayer
          className="react-player"
          url="https://vimeo.com/375482424"
          playing
          playsinline
          loop
          muted
          width="100%"
          height="100%"
          style={{
            width: "100%",
          }}
        />
      </PlayerWrapper>
      <InstagramFeed posts={data.allInstaNode} />
    </>
  )
}

IndexPage.propTypes = {
  data: propTypes.object.isRequired,
}

export const query = graphql`
  query InstagramPosts {
    allInstaNode(
      limit: 50
      filter: { mediaType: { eq: "IMAGE" } }
      sort: { fields: localFile___birthtime }
    ) {
      edges {
        node {
          original
          mediaType
        }
      }
    }
  }
`

export default IndexPage
